import styled from "styled-components";
import { Box } from "@rebass/grid";
import { STATUS_IMAGE } from "../../constants";

const STATUS_COLORS = {
  major_outage: "#c02600",
  partial_outage: "#db861f",
  degraded_performance: "#ecb320",
  operational: "#29B15C",
};

export const CardWrapper = styled(Box)`
  width: 100%;
  background: #ffffff;
  overflow: hidden;
  cursor: pointer;
  border-radius: 4px;
  position: relative;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 12px;
  padding-bottom: 12px;
  .incidentTimestamp {
    text-align: right;
  }

  .incidentReport {
    background: linear-gradient(180deg, #ffffff 2.56%, #f5f7f9 95.75%);
    border: 1px solid #e4e2e2;
    border-radius: 4px;
    padding: 9px 18px;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    display: block;
    width: 200px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 4px;
  }

  &.liveincident,
  &.ongoing {
    border-radius: 4px;
    background-color: #f5f7f9;
    .components-affected {
      background: none;
      border: 0;
    }
    .recents {
      font-size: 14px;
      line-height: 17px;
      color: #333;
      .title {
        font-weight: 600;
        padding-bottom: 30px;
      }
      .status {
        font-weight: 700;
      }
      .message {
        color: var(--base-font-color);
        font-weight: 400;
        line-height: 28px;
        a.message-link,
        .message-link {
          display: inline;
          color: #0066cc;
          text-decoration: underline;
          cursor: pointer;
          &:hover {
            color: #004499;
            text-decoration: underline;
          }
        }
      }
    }
  }

  // .recents {
  //   margin-left: 40px;
  // }
  &.liveincident,
  &.ongoing {
    .components-affected {
    }
  }
  .complistitem:first-child {
    margin-left: 0;
  }
  .complistitem {
    margin: 0 10px 4px 0;
  }

  @media only screen and (max-width: 600px) {
    &.liveincident,
    &.ongoing {
      .components-affected {
        margin-left: 0px;
      }
    }

    .recents {
      margin-left: 0;
    }
  }

  &.details {
    border: 0;
    background: #fff;
    cursor: auto;
    padding: 8px 16px 24px 16px;
    display: flex;
    justify-content: space-between;

    .components-affected {
      background: none;
      border: 0;
    }

    .incident-update {
      .timestamp.done {
        background: #e0f5f0;
        color: #007958;
      }
    }
    .updatesWrapper {
      border-top: 1px solid var(--divider-color);
      margin: 20px 0;
      padding: 30px 10px 0;
      font-size: 14px;
      font-weight: 400;

      &.empty {
        padding-top: 120px;
      }
    }
  }

  &.details {
    display: grid;
    width: 100%;
    grid-template-areas: ${({ cardAction }) =>
      cardAction
        ? `
    'incident-status . incident-follow'
      'incident-content . incident-duration'
      'incident-content . incident-services'
      'incident-updates . incident-services'
    `
        : `
    'incident-status . incident-duration'
      'incident-content . incident-services'
      'incident-content . incident-services'
      'incident-updates . incident-services'
    `};
    grid-template-columns: 1fr 20px 240px;

    .incident-status {
      grid-area: incident-status;
    }
    .incident-content {
      grid-area: incident-content;
    }
    .incident-duration {
      grid-area: incident-duration;
    }
    .incident-updates {
      grid-area: incident-updates;
    }
    .incident-services {
      grid-area: incident-services;
    }
    .incident-content {
      grid-area: incident-content;
    }
    .incident-content {
      grid-area: incident-content;
    }
    .incident-follow {
      grid-area: incident-follow;
    }
    @media only screen and (max-width: 600px) {
      grid-template-areas:
        "incident-status"
        "incident-follow"
        "incident-duration"
        "incident-content"
        "incident-services"
        "incident-updates";
      grid-template-columns: 1fr;

      .timestamp {
        font-size: 12px;
      }
      .incident-follow {
        margin-top: 10px;
      }
    }
  }

  .components-affected {
    min-height: 96px;
    max-height: 96px;
    box-sizing: border-box;
    padding: 8px 0px 0px 0px;
  }
`;

export const Upcoming = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
  text-align: center;
  color: #4d4d4d;
  border-radius: 3px;
  background-color: #e4f0ff;
  padding: 3px 10px;
  display: inline-block;
  margin-bottom: 5px;
  margin-right: 5px;
`;

export const OnGoing = styled.div`
  font-size: 12px;
  font-weight: 500;
  padding: 4px 8px;
  margin-right: 4px;
  background-color: #fff;
  border: 1px solid #fddbb5;
  color: #c13e1b;
  border-radius: 4px;
`;

export const Title = styled.div`
  font-weight: 600;
  font-size: ${(props) => (props.cardType === "details" ? "20px" : "18px")};
  line-height: ${(props) => (props.cardType === "details" ? "25px" : "20px")};
  cursor: ${(props) => (props.cardType === "details" ? "auto" : "pointer")};
  color: ${({ statusType }) =>
    statusType ? STATUS_COLORS[statusType] : "#A62800"} !important;
`;

export const ExtraValue = styled.div`
  color: #12344d;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 2px 0;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

export const ComponentValue = styled.div`
  display: flex;
  align-items: center;
  background: #f4f4f4;
  border: 1px solid #e7e7e7;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 12px;
  word-break: break-all;
  & > img {
    margin-right: 10px;
    width: 12px;
    height: 12px;
  }
  :not(:last-child) {
    margin-right: 10px;
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  :not(:last-child) {
    margin-bottom: 8px;
  }
  > * {
    margin-bottom: 8px;
  }
`;

export const Group = styled.span`
  font-size: 14px;
  line-height: 17px;
  color: #4a4545;
  word-break: break-all;
  &.parent {
    font-weight: 700;
  }
  .divider {
    margin-left: 8px;
    margin-right: 8px;
  }
`;

export const ComponentsContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: 14px;
  & > div.show-all {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 8px;
    & > span {
      margin-right: 8px;
    }
    & > svg {
      transition: transform 0.3s ease-out;
      transform: rotate(
        ${({ isShowAllRows }) => (isShowAllRows ? "180deg" : "0deg")}
      );
    }
  }
  & > hr {
    margin: 0 12px;
    flex: 1;
    background-color: var(--divider-color);
    height: 1px;
  }
`;

export const TimeStamp = styled.div`
  display: inline-block;
  color: #28292b !important;
  line-height: 17px;
`;

export const DescriptionContainer = styled.div`
  font-size: 14px;
  margin-bottom: 10px;
  white-space: pre-wrap;
  opacity: 0.8;
  max-height: 50px;
  overflow: hidden;

  .message {
    white-space: normal;
  }

  &.details,
  &.incident-card {
    padding-left: 0 !important;
  }
  @media only screen and (max-width: 600px) {
    padding-left: 0;
  }
  @media only screen and (max-width: 992px) {
    font-size: 12px;
  }
`;

export const LableTag = styled.div`
  box-sizing: border-box;
  border: 1px solid ${({ resolved }) => (resolved ? "#b4e5d9" : "#f5f7ff")};
  border-radius: ${({ resolved }) => (resolved ? "4px" : "2px")};
  background-color: ${({ resolved }) => (resolved ? "none" : "#f5f7ff")};
  font-size: 12px;
  font-weight: ${({ resolved }) => (resolved ? "600" : "500")};
  line-height: ${({ resolved }) => (resolved ? "1.5" : "22px")};
  color: ${({ resolved }) => (resolved ? "#007958" : "#5e96ea")};
  padding: ${({ resolved }) => (resolved ? "3px 8px" : "5px 11px")};
  text-align: center;
`;

export const Update = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  min-height: 60px;
  opacity: 0.8;
  color: #0b0d11 !important;

  .status {
    font-weight: 600;
    font-size: 18px;
    margin-bottom: 10px;
  }
  .time {
    font-size: 12px;
  }
  .updates {
    line-height: 1.43;
    max-width: 90%;
    min-height: 30px;
    white-space: pre-wrap;
    padding: 10px 5px;
  }
  .update-label {
    width: 33.33%;
  }
  .update-message {
    white-space: break-spaces;
    width: 66.66%;
  }
  @media only screen and (max-width: 600px) {
    flex-direction: column;

    .update-label {
      width: 100%;
    }
    .update-message {
      width: 100%;
    }
  }

  :not(:last-child) {
    margin-bottom: 26px;
  }
`;

export const IncidentHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;

  @media only screen and (max-width: 600px) {
    padding-left: 0;
    display: block;

    .last-updated {
      display: none;
    }
  }
`;

export const LabelInfo = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #172b4d;
  /* text-align: end; */
  .title {
    font-weight: 600;
  }

  .duration {
    width: 175px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    vertical-align: middle;
  }
  @media only screen and (max-width: 600px) {
    display: block;
    text-align: left;
    line-height: 1.5;
  }
`;

export const IncidentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  min-height: 96px;
  flex-grow: 1;
  .incidentTitle {
    font-weight: 600;
    font-size: 18px;
    line-height: 21px;
    cursor: pointer;
    width: 95%;
    color: ${({ statusType }) =>
      STATUS_COLORS[statusType] || "#A62800"} !important;
    @media only screen and (max-width: 992px) {
      font-size: 15px;
      line-height: 18px;
    }
  }

  .incident-title {
    display: flex;
    align-items: normal;
    padding-bottom: 6px;
    a {
      display: flex;
      flex-grow: 1;
      width: calc(100% - 35px);
    }
  }

  .incidentSymbol {
    width: 24px;
    min-width: 24px;
    height: 24px;
    background-size: 22px;
    background-repeat: no-repeat;
    display: block;
    margin-right: 15px;
    background-image: url(${({ statusType }) => STATUS_IMAGE[statusType]});
  }

  .updatesWrapper {
    margin-top: 30px;
    padding: 30px 10px 0;
    font-size: 14px;
    font-weight: 400;
  }
`;

const btnStyle = `
  padding: 4px 15px;
  border-radius: 3px;
  color: rgb(255, 255, 255);
  font-weight: 700;
  font-size: 12px;
`;

export const InvalidField = styled.div`
  width: 300px;
  color: rgb(215, 45, 48);
  text-align: left;
  line-height: 1.6;
  margin: 0 auto;
`;

export const StyledFollowIncident = styled.div`
  .follow-btn {
    ${btnStyle}
    background: var(--primary-color);
    cursor: pointer;
    height: 24px;
    line-height: 1.45;
    margin-left: ${({ details }) => (details ? 0 : "10px")};
  }
`;

export const ModalBody = styled.div`
  padding: 30px 50px 40px;
  text-align: center;
  font-size: 13px;
  input {
    width: 300px;
    margin-top: 20px;
  }
`;

export const ModalFooter = styled.div`
  padding: 12px 20px;
  border-top: 1px solid #e8e8ef;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .primary {
    ${btnStyle}
    padding: 6px 15px;
    cursor: pointer;
    background: var(--primary-color);
  }
  .secondary {
    margin-right: 10px;
    color: #172b4d;
    opacity: 0.56;
    cursor: pointer;
    background: white;
  }
`;
